import AbstractRepository from "@/repository/AbstractRepository";
import collect from "collect.js";

interface GrupoFilters { }

export default class GrupoServicoRepository extends AbstractRepository{
    static resource = 'grupo';

    public static async listar(filters: GrupoFilters = {}) {
        let response = await this.get(`${this.resource}`, filters);
        let lista = collect(response.dados);
        return lista;
    }
}
